module.exports = __webpack_public_path__ + "static/media/Position_7m.ca4fd6c8.jpg";